import React from 'react';

import { LancamentosView } from '../components/LancamentosView';

export const FinanceiroContasReceberPage = () => <LancamentosView tipo="RECEITA" />;
